import {createErrorAction} from './utils';

const TYPES = {
    GET_ACTIVE_USERS: 'GET_ACTIVE_USERS',
    GET_ACTIVE_USERS_COMPLETE: 'GET_ACTIVE_USERS_COMPLETE',
    GET_ACTIVE_USERS_FAILED: 'GET_ACTIVE_USERS_FAILED',
    RESET_DATA: 'ACTIVE_USERS_RESET_DATA'
};

export default {
    TYPES,

    getActiveUsers: payload => ({
        type: TYPES.GET_ACTIVE_USERS,
        payload
    }),

    getActiveUsersSuccess: payload => ({
        type: TYPES.GET_ACTIVE_USERS_COMPLETE,
        payload
    }),

    getActiveUsersFailed: createErrorAction(TYPES.GET_ACTIVE_USERS_FAILED),

    resetData: () => ({
        type: TYPES.RESET_DATA
    })
};
